import React, { Component } from 'react';
import './AssetDetailsExport.css'

class AssetDetailsExport extends Component {
    constructor(props) {
        super(props)

        this.state = {
            assetDetails: []
        }
    }


    // componentWillReceiveProps(incomingData) {
    //     methods = incomingData.methodDetails.shipment_tracking_method
    // }

    static getDerivedStateFromProps(nextProps, prevState) {
        // methods = nextProps.methodDetails.shipment_tracking_method
        return {
            assetDetails: nextProps.transporter_data?.truck_asset_details
        }
    }


    render() {
        return (
            <div>
                <h3 className="data_header">Truck / Asset Details</h3>
                <div className='overflow-auto'>
                <table id="methods" className='table table-bordered'>
                        <thead>
                          <tr>
                            <th className='table-1'>Truck Type</th>
                            <th className='table-2'>Self Owned</th>
                            <th className='table-3'>Average age of vehicles (year)</th>
                            <th className='table-3'>Attached vehicles</th>
                            <th className='table-3'>Major Vendor for attached vehicles</th>
                          </tr>
                        </thead>
                        {
                          (this.state.assetDetails === null || this.state.assetDetails === undefined || this.state.assetDetails.length === 0) ? (
                            <tbody>
                              <tr>
                                <td colSpan="4">
                                  Details not available
                                </td>
                              </tr>
                            </tbody>
                          ) : (<tbody>
                            {this.state.assetDetails.map((truck, index) =>
                              <tr key={index}>
                                <td className="table-1"> {truck.type} </td>
                                <td className="table-2"> {truck.self_owned}</td>
                                <td className="table-3"> {truck.avg_fleet_age}</td>
                                <td className="table-3"> {truck.planned_increase}</td>
                                <td className="table-3"> {truck.vendors}</td>
                              </tr>
                            )}
                          </tbody>

                          )
                        }
                      </table>
                </div>
            </div>
        )
    }
}

export default AssetDetailsExport
